import axios from 'axios'
import { metadataUrls } from '@/api/urls'
import { extractData, ApiVersionHeader } from '@/utils'

const options = { headers: Object.assign({ 'Content-Type': 'application/json' }, ApiVersionHeader), withCredentials: false }

export const retrieveMetadata = () => axios.get(metadataUrls.metadata(), options).then(extractData)

export default {
  retrieveMetadata
}
